import { useState,useEffect } from 'react';
import { PremiumPaywallSignModes } from '../../../../../global/paywall/paywallInterfaces';
import { PremiumCalcalistPaywallMobileSignUp as PremiumCalcalistPaywallMobileSignUp } from "./premiumCalcalistPaywallMobileSignup"
import { PremiumCalcalistPaywallMobileLogin as PremiumCalcalistPaywallMobileLogin } from './premiumCalcalistPaywallMobileLogin';
import { LinkTargetProperties } from "global/components/linkSettings/interfaces"
 
export interface LegalLink {
  url: string;
  target: LinkTargetProperties;
}
interface PremiumCalcalistPaywallMobileProps {
  setIsRedirecting: (isRedirect: boolean) => void;
  legalLinks: {terms: LegalLink; privacy: LegalLink};
}
export const PremiumCalcalistPaywallMobile = (props:PremiumCalcalistPaywallMobileProps) => {
  const [mode, setMode] = useState<PremiumPaywallSignModes>('signIn');
  const [emailOrPhone, setEmailOrPhone] = useState<string>('');
  const [agreesTerms, setAgreeTerms] = useState(false);
  const [password, setPassword] = useState('');
  const { setIsRedirecting,legalLinks } = props;

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);


  const getFormByMode = () => {
    if (mode === 'signUp') {
      return (
        <PremiumCalcalistPaywallMobileSignUp
          email={emailOrPhone}
          password={password}
          agreesTerms={agreesTerms}
          setEmail={setEmailOrPhone}
          setPassword={setPassword}
          setAgreesTerms={setAgreeTerms}
          setMode={setMode}
          setIsRedirecting={setIsRedirecting}
          legalLinks={legalLinks}
        />
      );
    }
    return (
      <PremiumCalcalistPaywallMobileLogin
        emailOrPhone={emailOrPhone}
        password={password}
        agreesTerms={agreesTerms}
        setEmailOrPhone={setEmailOrPhone}
        setPassword={setPassword}
        setAgreesTerms={setAgreeTerms}
        setMode={setMode}
        setIsRedirecting={setIsRedirecting}
      />);
  };

  return <div className="premium-calcalist-paywall-mobile">{getFormByMode()}</div>;
};
